const _state = {
  // This module primarily uses getters that depend on other state
}

const _getters = {
  /**
   * Returns sample open-ended responses with participant info and colors
   * @param {Object} _ - unused state
   * @param {Object} getters - module getters
   * @param {Object} __ - unused root state
   * @param {Object} rootGetters - root getters
   * @returns {Array} Array of sample responses with participant info and colors
   */
  sampleOpenEndedResponses: (_, getters, __, rootGetters) => {
    const selectedParticipantFields = rootGetters['slideSettingModule/selectedParticipantFields']
    const presentationColorPalette = rootGetters['presentationAttributeModule/presentationColorPalette']
    const presentationLighterColorPalette = rootGetters['presentationAttributeModule/presentationLighterColorPalette']
    const { isTextColourLight } = rootGetters

    const baseResponses = [
      {
        id: 1,
        title: 'Sample answer',
        audience: '1',
        audienceName: 'Jane Roe',
      },
      {
        id: 2,
        title: 'Sample answer',
        audience: '2',
        audienceName: 'Jim Hoe',
      },
      {
        id: 3,
        title: 'Sample answer',
        audience: '3',
        audienceName: 'John Doe',
      },
    ]

    if (selectedParticipantFields) {
      return baseResponses.map((response, index) => {
        const colorPaletteLength = presentationColorPalette.length
        const indexColor = index % colorPaletteLength
        let itemColor

        if (isTextColourLight) {
          itemColor = presentationLighterColorPalette[indexColor]
        } else {
          itemColor = presentationColorPalette[indexColor]
        }

        return {
          ...response,
          participantInfo: selectedParticipantFields.map((field) => {
            const capitalizedValue = field.name
              ? field.name.charAt(0).toUpperCase() + field.name.slice(1)
              : undefined
            return {
              name: field.name,
              value: capitalizedValue,
            }
          }),
          color: itemColor,
        }
      })
    }

    return baseResponses
  },

  /**
   * Determines whether to show sample responses
   * @param {Object} _ - unused state
   * @param {Object} getters - module getters
   * @param {Object} __ - unused root state
   * @param {Object} rootGetters - root getters
   * @returns {boolean} True if sample responses should be shown
   */
  shouldShowSampleResponses: (_, getters, __, rootGetters) => {
    const canUseOpenEndedSampleResponses = rootGetters['featureToggles/canUseOpenEndedSampleResponses']
    const slideActive = rootGetters['slideModule/slideActive']
    const { isPresenting } = rootGetters
    const { isBackstage } = rootGetters

    // Additional required state that needs to be passed from component
    // Since we don't have access to component-specific data like dataPageSelected
    // we'll return a function that can be called with that data
    return (dataPageSelected = {}, dataLength = 0) => {
      const isPresentingOrBackstage = isPresenting || isBackstage

      // Check if data is loaded and has empty options, OR if dataLength is 0
      const hasNoData = (dataPageSelected?.loaded && dataPageSelected?.options?.length === 0) || dataLength === 0

      if (canUseOpenEndedSampleResponses &&
        !slideActive.isOpenEndedGroupingLayout &&
        !slideActive.hideResult &&
        !isPresentingOrBackstage &&
        hasNoData
      ) {
        return true
      }

      return false
    }
  },
}

const _mutations = {
  // Add mutations if needed in the future
}

const _actions = {
  // Add actions if needed in the future
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  mutations: _mutations,
  actions: _actions,
}
